import { Splash } from './components/Features/Splash';

function App() {
  return (
    <div className="App">
      <Splash />
    </div>
  );
}

export default App;
